import { url } from 'inspector';
import { object, string, number, array ,date, InferType } from 'yup';

const GeneralRatesSchema = object({
    name: string().required().typeError('the name is required'),
    skill_sets: string().required().typeError('the skillsets is required'),
    description: string()
})

export default GeneralRatesSchema